<template>  
  <div style="width:100%;height:auto; margin:5px 0 auto auto;">
    <el-form>
      <el-row :gutter="20" v-if="this.onlyRead==null||this.onlyRead=='true'">
        <el-col :span="4" v-if="this.linevisable && !this.isOpen ">
          <el-button  type="primary" @click="drawLine">绘制折线</el-button>
        </el-col>
        <el-col :span="4" v-if="this.linevisable &&  this.isOpen">
          <el-button  type="primary" @click="OFFdrawLine">关闭绘制折线</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:5px">
        <el-col :span="24">
        <div id="amapcontainer"  :style="{width: divWidth, height: divHeight}"></div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
 
<script>
import bus from '@/eventBus/eventBus.js';
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: process.env.VUE_APP_AMAP_SECURITYCODE // '「申请的安全密钥」',
}
export default {
  props: { // 第二种方式
    lng: {
      type: String,
      required: true
    },
    lat: {
      type: String,
      required: true
    },
    visable: {
      type: String,
      required: true
    },
    mapLineAll: {
      type: String,
      required: true
    },
    onlyRead: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      linevisable:false,
      divWidth: '100%',
      divHeight: '420px',
      map: null,
      langLatAllList:[],
      marker1:null,
      isOpen:false,
      autoOptions: {
        input: ''
      },
      line:false,
      form:{
        province:'',//省
        city:'',//市
        district:''//区
      },
      placeSearch: null,
      searchPlaceInput: '',
      auto: null,
      geoCoder:null,
      polyline:null,
      
    }
  },
  created() {
   
    bus.$on('inputObject', val => {
      this.autoOptions.input = val.search_id
      this.searchPlaceInput = val.input
    })
    
    if (this.visable!=null) {
      
      this.linevisable=this.visable
    
    }
  },
  methods: {
    initAMap () {
      AMapLoader.load({
        key: process.env.VUE_APP_AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.ToolBar", "AMap.ControlBar", 'AMap.Geocoder', 'AMap.Marker',
          'AMap.CitySearch', 'AMap.Geolocation', 'AMap.AutoComplete', 'AMap.InfoWindow','AMap.mouseTool','AMap.PlaceSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // 获取到作为地图容器的DOM元素，创建地图实例
        this.map = new AMap.Map("amapcontainer", { //设置地图容器id
          resizeEnable: true,
          // zoom: this.zoom, // 地图显示的缩放级别
          viewMode: "3D", // 使用3D视图
          zoomEnable: true, // 地图是否可缩放，默认值为true
          dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
          zoom: 11, //初始化地图级别
          center: [113.300129, 40.076762], // 初始化中心点坐标 大同市
          // mapStyle: "amap://styles/darkblue", // 设置颜色底层
        })
      
        //-----------------------添加固定标记点--------------修改页面传入的坐标
        if(this.lng != null && this.lat!=null){
    
          this.marker1=new AMap.Marker({
          position:new AMap.LngLat(this.lat,this.lng),
          title:'大同',
          // visible: true // 添加此行以确保标记点可见
        })
        this.map.add(this.marker1)
        }else{
        console.log("没有固定点")
        }

      //-------------------------添加地图折线
      if(this.mapLineAll!=null){
        console.log("mapLineAll:")
        console.log(this.mapLineAll)
        this.langLatAllList=JSON.parse(this.mapLineAll);
        console.log("langLatAllList:")
        console.log(this.langLatAllList)
    
      }
          // 实例化Polyline类
      this.polyline = new AMap.Polyline({
    // 线条颜色
    strokeColor: "#3366FF",
    // 线条透明度
    strokeOpacity: 1,
    // 线条宽度
    strokeWeight: 5,
    // 折线样式，可选值：'solid'、'dashed'
    strokeStyle: "solid",
    // 是否延迟显示，支持在地图加载完毕后再显示
    geodesic: true,
    // 线条的坐标点数组
    path: this.langLatAllList,
    // 是否绘制成大地线
    isOutline: true,
    // 是否显示端点图标
    showDir: true
  });
  // 将Polyline对象添加到地图上
    this.map.add(this.polyline);
        //------------------关键字提示
         this.auto = new AMap.AutoComplete(this.autoOptions)
         //-----------------搜索
         this.placeSearch = new AMap.PlaceSearch({
            map: this.map
          }) 
          //构造地点查询类
          this.auto.on('select', this.select)
           //--------------------地址逆解析;
           this.geoCoder = new AMap.Geocoder({
            city: "010", //城市设为北京，默认：“全国”
            radius: 1000, //范围，默认：500
          });

       
      
        if(this.onlyRead==null||this.onlyRead=="true"){

       
          //-----------------点击获取经纬度
          this.map.on("click", (e) => {
          
            // 获取经纬度
            this.form.lng = e.lnglat.lng;
            this.form.lat = e.lnglat.lat;
            // 清除点
            this.removeMarker();
            // 标记点
            this.setMapMarker();
            //逆解析地址
            this.toGeoCoder();

             // 向折现中存 标记点
            this.setMapPolyline();
          });
        
       
          //-----------------右键事件
          this.map.on("rightclick", (e) => {
         
         // 清除折线点
         this.handleMapRightClick();
        
       });
      }
         
      }).catch(e => {
          console.log(e)
        })

       
        
      
     
    },
    select(e) {
      this.placeSearch.setCity(e.poi.adcode)
      this.placeSearch.search(e.poi.name) //关键字查询查询
      // this.map.setZoom(16, true, 1)
    },
    // 折线点
    setMapPolyline() {
      //如果在绘制折线中
      if(this.line){
      this.langLatAllList.push([this.form.lng,this.form.lat])
   
      this.form.lineAll=JSON.stringify(this.langLatAllList)
   
      this.toForm()
      this.polyline.setPath(this.langLatAllList);
       // 将Polyline对象添加到地图上
       this.map.add(this.polyline);
      

}
    },
     // 标记点
     setMapMarker() {
      //如果在绘制折线中
      if(!this.line){
      // 自动适应显示想显示的范围区域
      this.map.setFitView();
      this.marker = new this.AMap.Marker({
        map: this.map,
        position: [this.form.lng, this.form.lat],
      });
      this.map.setFitView();
      this.map.add(this.marker);
    }
    },
    // 清除点
    removeMarker() {
      //如果在绘制折线中
      if(!this.line){
        if (this.marker) {
        this.map.remove(this.marker);
      }
      
      if (this.marker1) {
        this.map.remove(this.marker1);
      }
      }
    
    },
    //清除最后的折线
    handleMapRightClick(e) {
      //如果在绘制折线中
      if(this.line){
      
     // 删除 langLatAllList 中的最后一个数组
     
      if (this.langLatAllList && this.langLatAllList.length > 0) {
        var marker2
        if(this.marker1!=null){
          marker2=this.marker1
        }
        if(this.marker!=null){
          marker2=this.marker
        }

  // 更新折线的路径
  
     //删除所有
     this.map.clearMap()
     this.langLatAllList.pop();
     
     
    //重新添加折线
    this.polyline.setPath(this.langLatAllList);
    // 将Polyline对象添加到地图上
    this.map.add(this.polyline);
    // 如果折线已经没有坐标点，从地图上移除
       // 将marker对象添加到地图上
       this.map.add(marker2);
       this.form.lineAll=JSON.stringify(this.langLatAllList)
   
   
       this.toForm()
     
 
  }
    
      }
    },
     // 绘制折线
     drawLine () {
    this.line=true
    this.isOpen=true

    },
      // 停止绘制折线
    OFFdrawLine () {
    this.line=false
    this.isOpen=false
    },
   
    // 逆解析地址
    toGeoCoder() {
      //如果在绘制折线中
      if(!this.line){
      let lnglat = [this.form.lng, this.form.lat];
      this.geoCoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.regeocode) {
          this.form.address = result.regeocode.formattedAddress;
          this.form.province = result.regeocode.addressComponent.province;
          this.form.city = result.regeocode.addressComponent.city;
          this.form.district = result.regeocode.addressComponent.district;
          
          this.toForm()

        }
        
      });
        
    }
    },
    //将信息传入表单中
    toForm() {
      
      this.$emit("getData", this.form);
    }

  },
  mounted () {
    //DOM初始化完成进行地图初始化
    this.initAMap()
  },
  watch: {
    searchPlaceInput(newValue) {
      if (newValue != null) {
        this.placeSearch.search(newValue)
      }
    }
  }

}
</script>
 
<style lang="less">
  .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 50px;
        .label {
            width: 100px;
        }
    }
    .amap-sug-result {
        z-index: 9999 !important;
    }


</style>